import React from 'react';
import { Alert, Button, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { ccErrorCode } from '../../services/CCPublicationService';
import { isMapPreview } from './publicationContract';

export function CCError({ error, retry }) {
  const { t } = useTranslation('translation');
  const code = ccErrorCode(error);
  const key = ({ ci_not_enabled: 'serviceUnavailable', ci_database_unconfigured: 'serviceUnavailable',
    ci_no_territory: 'noAssignments', ci_forbidden: 'denied', ci_identity_not_registered: 'denied',
    ci_access_changed: 'accessChanged', ci_access_revoked: 'accessChanged', ci_revision_conflict: 'conflict',
    ci_map_scope_not_found: 'scopeExpired', ci_too_many_map_scopes: 'busy', ci_map_busy: 'busy',
    ci_auth_busy: 'busy', ci_database_busy: 'busy' })[code] || 'requestFailed';
  return <Alert type="warning" showIcon message={t(`ci.${key}`)} action={retry && <Button size="small" onClick={retry}>{t('cc.retry')}</Button>} />;
}
export function CCResourceState({ result, retry }) {
  const { t } = useTranslation('translation');
  if (result.status === 'loading') return <Spin size="small" aria-label={t('cc.loading')} />;
  if (result.status === 'error') return <CCError error={result.error} retry={retry} />;
  return null;
}
export function CCCoverage({ value, snapshot }) {
  const { t } = useTranslation('translation');
  if (isMapPreview(snapshot)) return <div className="ci-coverage ci-coverage-unavailable">{t('ci.mapPreview')}</div>;
  if (!value) return null;
  return <details className={`ci-coverage ci-coverage-${value.status.toLowerCase()}`}>
    <summary>{t(`ci.coverage${value.status}`)}</summary>
    <p>{value.summary}</p>
    {value.expected_unit_count != null && <p>{value.covered_unit_count} / {value.expected_unit_count} {t('ci.coveredUnits')}</p>}
    {value.coverage_percentage != null && <p>{t('ci.geographicCoverage')}: {value.coverage_percentage}%</p>}
    {value.status === 'PARTIAL' && <p>{t('ci.coverageHelp')}</p>}
  </details>;
}
